import { useEffect, useState } from "react";

interface UsePopupBackgroundProps {
  isOpen: boolean;
}

export const usePopupBackground = ({ isOpen }: UsePopupBackgroundProps) => {
  const [showBackground, setShowBackground] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowBackground(isOpen), 100);
  }, [isOpen]);

  return { showBackground };
};
